// import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import "../styles/ReviewForm.css";
import { Link } from "react-router-dom";
import reviewVideo from "../assets/hotel-review-bg.mp4";
import { useLocation } from "react-router-dom";
import { FaHotel, FaCommentDots } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const ReviewForm = () => {
  const [ratings, setRatings] = useState({
    decoration: 0,
    weddingHall: 0,
    foodSpread: 0,
    foodTaste: 0,
    service: 0,
    cleanliness: 0,
    overall: 0,
  });
  const [review, setReview] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hotelName = queryParams.get("hotel") || "Centauria Lake Hotel";
  const hallName = queryParams.get("hall") || "Lake side banquet hall"; // Default hall name
  const mealtype = queryParams.get("meal") || "Wedding"; // Default meal optio
  const [selectedMeal, setSelectedMeal] = useState("");
  const SERVICE_ID = "service_67xh1uo";     // Replace with your EmailJS Service ID
  const TEMPLATE_ID = "template_ol1citd";   // Replace with your EmailJS Template ID
  const PUBLIC_KEY = "hsCjAmsMh29aMNasg";     // Replace with your EmailJS Public Key
  const navigate = useNavigate();
  const [ipAddress, setIpAddress] = useState("Unknown");

  const handleRating = (type, value) => {
    setRatings({ ...ratings, [type]: value });
  };

  // const [selectedMeals, setSelectedMeals] = useState([]);

  const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const isValidPhone = (phone) =>
  /^\d{10}$/.test(phone);

  const isFormValid =
  Object.values(ratings).every((val) => val > 0) ;
  // review.trim() &&
  // name.trim() &&
  // selectedMeals.length > 0 ;
  // isValidEmail(email);

  // const mealOptionsList = [
  // // "Dinner Buffet",
  // // "Lunch Buffet",
  // // "Breakfast Buffet",
  // // "À la carte",
  // "Wedding",
  // "Other"
  // ];

  // const handleMealToggle = (option) => {
  //   setSelectedMeals((prev) =>
  //     prev.includes(option) 
  //       ? prev.filter((o) => o !== option)
  //       : [...prev, option]
  //   );
  // };

  const handleSubmit = async () => {
    const templateParams = {
      name: name || "None",
      email: email || "None",
      phone: phone || "None",
      hotel_name: hotelName,
      hall: hallName,
      meal:mealtype,
      // meals: Array.isArray(selectedMeals) ? selectedMeals.join(", ") : selectedMeals || "None",
      overall: ratings.overall,
      decoration: ratings.decoration,
      weddingHall: ratings.weddingHall,
      foodSpread: ratings.foodSpread,
      foodTaste: ratings.foodTaste,
      service: ratings.service,
      cleanliness: ratings.cleanliness,
      review: review || "None",
      ip_address: ipAddress,
      submitted_at: new Date().toLocaleString(),
    };

    try {
      // 1. Save to Firestore
      await addDoc(collection(db, "hotelReviews"), {
        ...ratings,
        review,
        name,
        email,
        phone,
        mealtype,
        // mealOptions: selectedMeals,
        createdAt: new Date(),
        hotelName,
        hallName,
        ipAddress,
      });

      navigate("/thank-you");

      // 2. Send Email
      await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, {
        publicKey: PUBLIC_KEY,
      });

      // alert("🍽️ Thanks for your feedback! Your review was submitted and emailed 😊");

      // 3. Reset form
      setRatings({  decoration: 0, weddingHall: 0, foodSpread: 0, foodTaste: 0, service: 0, cleanliness: 0, overall: 0 });
      setReview("");
      setName("");
      setEmail("");
      // setSelectedMeals([]);
    } catch (error) {
      console.error("Error submitting review or sending email:", error);
      alert("❌ Submission failed or email not sent. Please try again.");
    }
  };


  const renderStars = (type) =>
    Array.from({ length: 5 }, (_, i) => (
      <span
        key={i}
        className={i < ratings[type] ? "star filled" : "star"}
        onClick={() => handleRating(type, i + 1)}
      >
        ★
      </span>
    ));

    useEffect(() => {
      fetch("https://api.ipify.org?format=json")
        .then((res) => res.json())
        .then((data) => setIpAddress(data.ip))
        .catch((err) => console.error("IP fetch failed", err));
    }, []);

    const ratingLabels = {
      decoration: "Decore (මල් සැරසිලි)",
      weddingHall: "Wedding Hall (විවාහ ශාලාව)",
      foodSpread: "Food Spread (ආහාර විවිදත්වය)",
      foodTaste: "Food Taste (ආහාර රසය)",
      service: "Service (සේවාව)",
      cleanliness: "Cleanliness (පිරිසිදුභාවය)",
      overall: "Overall (සමස්තව)",
    };


    return (
    <div className="review-wrapper">
      {/* Overlay */}
      <div className="review-overlay"></div>

      {/* Review Form */}
      <div className="review-container">
        <div className="logo-heading">
          <img src="/hotels.png" alt="Hotel Logo" />
        </div>

       {/* <h2>
         <FaHotel className="animated-icon" style={{ marginRight: "10px" }} />
          Centuria Group of Hotels
        </h2> */}
        <hr />
        <h3>
          <FaCommentDots style={{ marginRight: "8px", color: "#252427" }} />
          Please Provide Your Feedback
        </h3>

          <div className="meal-options">
            {/* <p style={{ fontWeight: "bold", marginBottom: "5px" }}>Meal Options</p> */}
            
            {/* <div className="meal-grid">
              {mealOptionsList.map((option, index) => (
                <label key={index} className="meal-option">
                  <input
                    type="radio"
                    name="meal" // all radios must share the same name
                    checked={selectedMeals === option}
                    onChange={() => setSelectedMeals(option)}
                  />
                  {option}
                </label>
              ))}
            </div> */}
          

          <h4>Customer Review</h4>
          <hr />


          {["decoration", "weddingHall", "foodSpread", "foodTaste", "service", "cleanliness", "overall"].map((type) => (
            <div key={type} className="rating-row">
              <label>{ratingLabels[type]}</label>
              <div>{renderStars(type)}</div>
            </div>
          ))}

        
          <textarea
            placeholder="Customer Suggestion..."
            value={review}
            onChange={(e) => setReview(e.target.value)}
        />
        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {email && !isValidEmail(email) && (
          <p style={{ color: "red", fontSize: "13px", marginTop: "-8px" }}>
            Please enter a valid email address.
          </p>

          )}

         <input
          type="tel"
          placeholder="Mobile no"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />

          {phone && !isValidPhone(phone) && (
            <p style={{ color: "red", fontSize: "13px", marginTop: "-8px" }}>
              Please enter a valid 10-digit phone number.
            </p>
          )}

        
        </div>
        <hr></hr>

        {isFormValid && (
          <button className="submit-btn" onClick={handleSubmit}>
            Submit Review
          </button>
        )}

        {/* <p style={{ textAlign: "center", marginTop: "10px" }}>
          <Link to="/admin-login" style={{ color: "gold" }}>
            View Admin Panel
          </Link>
        </p> */}
      </div>
      </div>
    
  );
};

export default ReviewForm;
